// extracted by mini-css-extract-plugin
module.exports = {"cylinder_container":"MegamiSlot_cylinder_container_2HHMb","button_container":"MegamiSlot_button_container_8Pe2h","share_container":"MegamiSlot_share_container_2P2v_"};